import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useRetroBrightProjects(itemId: string) {
  return useQuery({
    queryKey: ['retrobright', itemId],
    queryFn: () => apiClient.getRetroBrightProjects(itemId),
    enabled: !!itemId,
  });
}

export function useRetroBrightProject(projectId: string) {
  return useQuery({
    queryKey: ['retrobright', 'project', projectId],
    queryFn: () => apiClient.getRetroBrightProject(projectId),
    enabled: !!projectId,
  });
}

export function useCreateRetroBright() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: string; data: any }) =>
      apiClient.createRetroBright(itemId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['retrobright', variables.itemId] });
    },
  });
}

export function useUpdateRetroBright() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, data }: { projectId: string; data: any }) =>
      apiClient.updateRetroBright(projectId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['retrobright'] });
    },
  });
}

export function useStartSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, notes }: { projectId: string; notes?: string }) =>
      apiClient.startRetroBrightSession(projectId, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['retrobright'] });
    },
  });
}

export function useStopSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (projectId: string) => apiClient.stopRetroBrightSession(projectId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['retrobright'] });
    },
  });
}
